import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.string().min(1).default('/api'),
});

/** Variables d'env validées au démarrage : échec bruyant plutôt que 404 silencieux. */
export const env = envSchema.parse(import.meta.env);
